export default __webpack_public_path__ + "static/3-babb9705bfb91e7186b6026c686b4308.png";